import { DOCUMENT } from "@angular/common";
import { AfterViewInit, Component, Inject, Renderer2, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { ExchangeService } from "@aparraga/ahoracrypto-client-common/src/app/common/exchange/exchange.service";
import {
  PurchaseFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/purchaseflowhelper.service";
import {
  RegistrationFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/registrationflowhelper.service";
import { NavigationService } from "@aparraga/ahoracrypto-client-common/src/app/common/navigation/navigation.service";
import { IS_BROWSER } from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";
import { StringUtils } from "@aparraga/ahoracrypto-client-common/src/app/common/utils/stringutils";
import { JsLoaderService } from "../../jsloader/jsloader.service";
import { WebFlowContainerComponent } from "../webflowcontainer.component";

@Component({
    selector: 'cryptohero1',
    templateUrl: './cryptohero1.component.html',
    styleUrls: [
        './css/custom.scss',
        './css/normalize.scss',
        './css/webflow.scss',
        './css/ahoracryptoes-54c43cd2d8f-daf1d3078fd47.webflow.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CryptoHero1Component extends WebFlowContainerComponent implements AfterViewInit {

  //data-wf-page="66108a3a9eacb0568e99aee6" data-wf-site="65f2040920efdcba4918e3a2">
  protected override webflowPage = '66108a3a9eacb0568e99aee6';
  protected override webflowSite = '65f2040920efdcba4918e3a2';
  protected override resources = [
    '/assets/landings/cryptohero1/js/webflow.js',
  ]

  public constructor(
    @Inject(IS_BROWSER) protected override isBrowser: boolean,
    @Inject(DOCUMENT) protected override document: Document,
    protected override jsLoaderService: JsLoaderService,
    protected router: Router,
    protected exchangeService: ExchangeService,
    private renderer: Renderer2,
    protected navigationService: NavigationService,
    public purchaseFlowHelperService: PurchaseFlowHelperService,
    public registrationFlowHelperService: RegistrationFlowHelperService,
    protected stringUtils: StringUtils) {
    super();
  }

  ngAfterViewInit() {
    this.configureWebflow();
  }

}
